import { setHours, setMinutes } from "date-fns";

export const getDateWithCorrectTime = (date: Date, hours: number, minutes: number): Date =>
  setMinutes(setHours(date, hours), minutes);
